import { includes } from 'lodash';
import { Dispatch } from 'redux';
import { NETWORK_ERROR_MODAL_TITLE } from '@mm/constants/error-descriptions';
import { UNPROCESSABLE_ENTITY } from '@mm/constants/status-codes';
import { getErrorJson } from '@mm/utils';
import { unbusyAll } from '../actions/commonActions';
import modalActions from '../modules/modalsState/actions';
import { StoreState } from '../store-interfaces';
import commonHandler, { ResponseOrError } from './common-handler';
import somethingWentWrong from 'assets/something-went-wrong.png';

export const pageGroupErrorHandler =
  (dispatch: Dispatch<StoreState>) => async (error: ResponseOrError) => {
    if (error instanceof Response && error.status === UNPROCESSABLE_ENTITY) {
      const CANNOT_DELETE = 'Cannot delete ';
      const responseErrorBody = await getErrorJson(error);

      if (includes(responseErrorBody.errors[0], CANNOT_DELETE)) {
        dispatch(unbusyAll());

        const errorText = responseErrorBody && responseErrorBody.errors;

        dispatch(
          modalActions.openPrettyErrorModal({
            title: NETWORK_ERROR_MODAL_TITLE,
            detailsForNerds: errorText,
            contactSupport: true,
            image: somethingWentWrong,
          }),
        );
      }
    } else {
      commonHandler(dispatch)(error);
    }
  };
